import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function IncorrectUrl() {
    const navigate = useNavigate();
    useEffect(() => {
            navigate("/metrics");
        }, [navigate]);
}
